import React, { Component } from "react"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import Network from "react-network"
import { translate } from "react-i18next"
import Header from "./Components/Layout/Header"
import LeftNav from "./Components/Layout/LeftNav"
import LanguagePicker from "./Components/Layout/LanguagePicker"
import Dashboard1 from "./Dashboard1"
import Dashboard2 from "./Dashboard2"
import Http404 from "./errors/Http404"
import "./App.scss"

class App extends Component {
  componentDidMount() {
    document.body.className = "fix-header fix-sidebar card-no-border"
    this.addScriptToBody("/bootstrap/assets/plugins/jquery/jquery.min.js")
    this.addScriptToBody("/bootstrap/assets/plugins/bootstrap/js/tether.min.js")
    this.addScriptToBody("/bootstrap/assets/plugins/bootstrap/js/bootstrap.min.js")
    this.addScriptToBody("/bootstrap/lite/js/jquery.slimscroll.js")
    this.addScriptToBody("/bootstrap/lite/js/waves.js")
    this.addScriptToBody("/bootstrap/lite/js/sidebarmenu.js")
    this.addScriptToBody("/bootstrap/assets/plugins/sticky-kit-master/dist/sticky-kit.min.js")
    this.addScriptToBody("/bootstrap/lite/js/custom.js")
  }

  addScriptToBody(src) {
    var tag = document.createElement("script")
    tag.async = false
    tag.src = src
    document.body.appendChild(tag)
  }

  render() {
    const { t, i18n } = this.props

    const offlineMessage = t("NoConnnectionMessage")

    return (
      <div className="App">
        <div className="preloader"> </div>
        <Router>
          <div id="main-wrapper">
            <Header />
            <LeftNav />
            <div className="page-wrapper">
              <div className="container-fluid">
                <Switch>
                  <Route exact path="/" component={Dashboard1} />
                  <Route path="/dashboard2" component={Dashboard2} />
                  <Route component={Http404} />
                </Switch>
                <Network
                  render={({ online }) => {
                    if (!online) {
                      return (
                        <div className="alert alert-danger" role="alert">
                          {offlineMessage}
                        </div>
                      )
                    }
                    return null
                  }}
                />
              </div>
              <footer className="footer">
                <LanguagePicker />
              </footer>
            </div>
          </div>
        </Router>
      </div>
    )
  }
}

export default translate("translations")(App)



// WEBPACK FOOTER //
// ./src/App.js